import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

// Access token lives in memory only; refresh token in sessionStorage (cleared when the tab closes).
// Needed because the preview iframe / iOS Safari block the httpOnly auth cookies.
const REFRESH_KEY = "posfinder_refresh";
let accessToken = null;
let memRefresh = null;

const storage = {
  get: () => {
    try { return sessionStorage.getItem(REFRESH_KEY); } catch (e) { console.warn("sessionStorage unavailable", e); return null; }
  },
  set: (v) => {
    try { v ? sessionStorage.setItem(REFRESH_KEY, v) : sessionStorage.removeItem(REFRESH_KEY); } catch (e) { console.warn("sessionStorage unavailable", e); }
  },
};

export const saveTokens = (d) => {
  if (!d?.access_token) return;
  accessToken = d.access_token;
  memRefresh = d.refresh_token;
  storage.set(d.refresh_token);
};
export const clearTokens = () => {
  accessToken = null;
  memRefresh = null;
  storage.set(null);
};
const refreshToken = () => memRefresh || storage.get();

api.interceptors.request.use((cfg) => {
  if (accessToken) cfg.headers.Authorization = `Bearer ${accessToken}`;
  return cfg;
});

export const refreshSession = () =>
  api.post("/auth/refresh", { refresh_token: refreshToken() }).then((r) => { saveTokens(r.data); return r; });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config;
    const url = cfg?.url || "";
    if (err.response?.status === 401 && !cfg._retry && !url.includes("/auth/")) {
      cfg._retry = true;
      refreshing = refreshing || refreshSession().finally(() => (refreshing = null));
      try {
        await refreshing;
        return api(cfg);
      } catch {
        window.dispatchEvent(new Event("auth:logout"));
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}
